import { GetterTree } from 'vuex'
import { UserPermissionsModel, UserSettingsModel } from './models'
import { UserSettingsGetter, UserSettingsState } from './types'
import { Permission, Permissions } from '../common'

export const getters: GetterTree<UserSettingsState, {}> = {
  [UserSettingsGetter.currentUserSettings]({ currentUserSettings }): UserSettingsModel {
    return currentUserSettings
  },
  [UserSettingsGetter.isFeatureOn]({ currentUserSettings }) {
    return (featureId: string): boolean => {
      return currentUserSettings.featureSwitches.includes(featureId)
    }
  },
  [UserSettingsGetter.isEmailMfaEnabled]({ currentUserSettings }): boolean | null {
    return currentUserSettings.emailMfaEnabled
  },
  [UserSettingsGetter.currentUserPermissions]({ currentUserPermissions }): UserPermissionsModel[] {
    return currentUserPermissions
  },
  [UserSettingsGetter.hasPermission]({ currentUserPermissions }) {
    return (id: Permissions, permission: Permission): boolean => {
      return currentUserPermissions.find((p) => p.id === id)?.permissions.includes(permission) ?? false
    }
  },
}
